module.exports = __webpack_public_path__ + "static/media/CosAssessmentsEveryDeploy2.f92cdfd7.png";